module.exports = __webpack_public_path__ + "static/media/PaymentService.cc334d31.svg";